import { Sparkles } from "lucide-react";

function StatusBadge({ status }) {
  const active = status === "shadow_observing";
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
      active ? "bg-emerald-500/20 text-emerald-300" : "bg-gray-600/30 text-gray-400"
    }`}>
      <span className={`w-1.5 h-1.5 rounded-full ${active ? "bg-emerald-400 animate-pulse" : "bg-gray-500"}`} />
      {active ? "A observar" : (status ?? "inativo")}
    </span>
  );
}

export function KarolStatusHeader({ karolStatus }) {
  return (
    <div className="bg-gray-900 rounded-2xl p-5 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-emerald-500/20 rounded-xl flex items-center justify-center">
          <Sparkles className="w-5 h-5 text-emerald-400" />
        </div>
        <div>
          <p className="text-white font-semibold text-sm">Karol Central</p>
          <p className="text-gray-400 text-xs">Inteligência operacional · modo observação</p>
        </div>
      </div>
      <StatusBadge status={karolStatus} />
    </div>
  );
}
